import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faHouse,
  faFileCirclePlus,
  faUserGear,
  faUserShield,
  faPenNib,
  faHandHoldingDollar,
  faHandshake,
  faBell,
  faPeopleArrows,
  faHeart,
  faFilter,
  faTag,
  faUserSecret,
  faShopLock,
  faParachuteBox,
  faTicket,
  faCog,
} from "@fortawesome/free-solid-svg-icons";

<i class="fa-solid fa-people-arrows"></i>;

export const Sidenav = () => {
  const location = useLocation();
  const [dashboardMenu, setDashBoardMenu] = useState("");
  const [accountMenu, setAccountMenu] = useState("");
  const { pathname } = location;

  const handleDashboardMenu = () => {
    if (dashboardMenu === "open") {
      setDashBoardMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setDashBoardMenu("");
      }, 200);
    } else {
      setDashBoardMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setDashBoardMenu("open");
      }, 200);
    }
  };

  const handleAccountMenu = () => {
    if (accountMenu === "open") {
      setAccountMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setAccountMenu("");
      }, 200);
    } else {
      setAccountMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setAccountMenu("open");
      }, 200);
    }
  };

  return (
    <aside
      id="layout-menu"
      className="layout-menu menu-vertical menu bg-menu-theme"
    >
      <div className="app-brand demo">
        <div className="app-brand-link">
          <span className="app-brand-logo demo">
          <img
              src="../../assets/img/flowersvg.svg"
              alt="Zenosure Logo"
              style={{
                width: "40px",
                height: "26px",
                borderRadius: "50%",
              }}
            />
          </span>
          <span className="app-brand-text demo menu-text fw-bold ms-0">
            Zenosure
          </span>
        </div>

        {/* <a
          href="javascript:void(0);"
          className="layout-menu-toggle menu-link text-large ms-auto"
        >
          <i className="ti menu-toggle-icon d-none d-xl-block ti-sm align-middle"></i>
          <i className="ti ti-x d-block d-xl-none ti-sm align-middle"></i>
        </a> */}
      </div>

      <div className="menu-inner-shadow"></div>

      <ul className="menu-inner py-1">
        <li className={`menu-item ${pathname === "/dashboard" && "active"}`}>
          <Link to="/dashboard" className="menu-link ">
            <div data-i18n="Dashboard">
              {" "}
              <FontAwesomeIcon icon={faHouse} size="xs" className="me-2" />
              Dashboard
            </div>
          </Link>
        </li>
        <li className={`menu-item ${(pathname === "/showplansall" || pathname.startsWith("/selectedPlan") || pathname.startsWith("/plansEdit") || pathname.startsWith("/addPlan")) ? "active" : ""}`}>
          <Link to="/showplansall" className="menu-link ">
            <div data-i18n="Dashboard">
              {" "}
              <FontAwesomeIcon icon={faHeart} size="xs" className="me-2" />
              Plans
            </div>
          </Link>
        </li>
        <li className={`menu-item ${(pathname === "/memberships" ||pathname === "/confirmation" || pathname.startsWith("/membershipDetails") || pathname.startsWith("/userDetailsEdit") || pathname.startsWith("/addUser"))? "active" : "" }`}>
          <Link to="/memberships" className="menu-link ">
            <div data-i18n="Dashboard">
              {" "}
              <FontAwesomeIcon
                icon={faPeopleArrows}
                size="xs"
                className="me-2"
              />
              Users
            </div>
          </Link>
        </li>
          <li className={`menu-item ${(pathname === "/corporatesUsers" || pathname.startsWith("/corporatesDetails") || pathname === "/addCorporates" ) ? "active" : ""}`}>
          <Link to="/corporatesUsers" className="menu-link ">
            <div data-i18n="Dashboard">
              
              <FontAwesomeIcon
                icon={faUser}
                size="xs"
                className="me-2"
              />
              Corporates User
            </div>
          </Link>
        </li>
        <li className={`menu-item ${(pathname === "/corporates" || pathname.startsWith("/corperatesDetails") ) ? "active" : ""}`}>
          <Link to="/corporates" className="menu-link ">
            <div data-i18n="Dashboard">
              
              <FontAwesomeIcon
                icon={faFileCirclePlus}
                size="xs"
                className="me-2"
              />
              Corporates
            </div>
          </Link>
        </li>

        <li
          className={`menu-item active ${dashboardMenu} ${
           pathname === "/Partnerwithus"|| pathname === "/PrivacyPolicy" ||  pathname === "/termsConditions" ||   pathname === "/aboutUs" ||   pathname === "/permissions" ? "open" : ""
          }`}
          onClick={handleDashboardMenu}
        >
          <button className="menu-link menu-toggle" style={{ background: 'none', border: 'none', width: '100%', textAlign: 'left' }}>
            <div data-i18n="Dashboard">
              {" "}
              <FontAwesomeIcon icon={faUserGear} size="xs" className="me-2" />
              Settings
            </div>
          </button>
          <ul className="menu-sub" style={{ listStyle: "none" }}>
            <li className={`menu-item ${pathname === "/Partnerwithus" && "active"}`}>
              <Link to="/Partnerwithus" className="menu-link">
                <FontAwesomeIcon icon={faUser} size="xs" className="me-2" />{" "}
                 Partner with us
              </Link>
            </li>
            <li className={`menu-item ${pathname === "/PrivacyPolicy" && "active"}`}>
              <Link to="/PrivacyPolicy" className="menu-link">
                <FontAwesomeIcon icon={faUserSecret} size="xs" className="me-2" />{" "}
                Privacy policy
              </Link>
            </li>
            <li className={`menu-item ${pathname === "/termsConditions" && "active"}`}>
              <Link to="/termsConditions" className="menu-link">
                <FontAwesomeIcon icon={faFilter} size="xs" className="me-2" />{" "}
                Terms and conditions
              </Link>
            </li>
            <li className={`menu-item ${pathname === "/aboutUs" && "active"}`}>
              <Link to="/aboutUs" className="menu-link">
                <FontAwesomeIcon icon={faTag} size="xs" className="me-2" />{" "}
                About us
              </Link>
            </li>
            <li className={`menu-item ${pathname === "/permissions" && "active"}`}>
              <Link to="/permissions" className="menu-link">
                <FontAwesomeIcon icon={faShopLock} size="xs" className="me-2" />{" "}
                Permissions
              </Link>
            </li>
          </ul>
        </li>

        <li
          className={`menu-item active ${accountMenu}`}
          onClick={handleAccountMenu}
        >
          <button className="menu-link menu-toggle" style={{ background: 'none', border: 'none', width: '100%', textAlign: 'left' }}>
            <div data-i18n="Account Settings">
              <FontAwesomeIcon icon={faUserShield} size="xs" className="me-2" />{" "}
              Security
            </div>
          </button>
          <ul className="menu-sub">
            <li
              className={`menu-item ${
                pathname === "#" && "active"
              }`}
            >
              <Link to="#" className="menu-link">
                <div data-i18n="Account">
                  <FontAwesomeIcon icon={faPenNib} size="xs" className="me-2" />{" "}
                  Reset password
                </div>
              </Link>
            </li>
          </ul>
        </li>
        <li className={`menu-item ${(pathname === "/partners" || pathname.startsWith("/partnersDetails") || pathname === "/addPartner" || pathname.startsWith("/editPartner")) ? "active" : ""}`}>
          <Link to="/partners" className="menu-link ">
            <div data-i18n="Dashboard">
              {" "}
              <FontAwesomeIcon icon={faParachuteBox} size="xs" className="me-2" />
              Partners
            </div>
          </Link>
        </li>
        <li className={`menu-item ${(pathname === "/partnerCategories" || pathname === "/addPartnerCategory" || pathname.startsWith("/editPartnerCategory")) ? "active" : ""}`}>
          <Link to="/partnerCategories" className="menu-link ">
            <div data-i18n="Dashboard">
              {" "}
              <FontAwesomeIcon icon={faTag} size="xs" className="me-2" />
              Partner Categories
            </div>
          </Link>
        </li>
        <li className={`menu-item ${(pathname === "/services" || pathname === "/addService" || pathname.startsWith("/editService")) ? "active" : ""}`}>
          <Link to="/services" className="menu-link ">
            <div data-i18n="Dashboard">
              {" "}
              <FontAwesomeIcon icon={faCog} size="xs" className="me-2" />
              Services
            </div>
          </Link>
        </li>
        <li className={`menu-item ${(pathname === "/cities" || pathname === "/addCity" || pathname.startsWith("/editCity")) ? "active" : ""}`}>
          <Link to="/cities" className="menu-link ">
            <div data-i18n="Dashboard">
              {" "}
              <FontAwesomeIcon icon={faFileCirclePlus} size="xs" className="me-2" />
              Cities
            </div>
          </Link>
        </li>
        <li className={`menu-item ${(pathname === "/promocodes" || pathname.startsWith("/promocodeDetails") || pathname === "/addPromocode" || pathname.startsWith("/editPromocode")) ? "active" : ""}`}>
          <Link to="/promocodes" className="menu-link ">
            <div data-i18n="Dashboard">
              {" "}
              <FontAwesomeIcon icon={faTicket} size="xs" className="me-2" />
              Promocodes
            </div>
          </Link>
        </li>
        <li className={`menu-item `}>
          <Link to="/dashboard" className="menu-link ">
            <div data-i18n="Dashboard">
              <FontAwesomeIcon
                icon={faHandHoldingDollar}
                size="xs"
                className="me-2"
              />{" "}
              Manage Payments
            </div>
          </Link>
        </li>

        <li className={`menu-item `}>
          <Link to="/dashboard" className="menu-link ">
            <div data-i18n="Dashboard">
              <FontAwesomeIcon icon={faHandshake} size="xs" className="me-2" />
              Help
            </div>
          </Link>
        </li>
        <li className={`menu-item `}>
          <Link to="/dashboard" className="menu-link ">
            <div data-i18n="Dashboard">
              <FontAwesomeIcon icon={faBell} size="xs" className="me-2" />{" "}
              Notifications
            </div>
          </Link>
        </li>
      </ul>
    </aside>
  );
};
